import { gql } from '@/__generated__/gql';

export const GET_ALLOCATION_COMPLIANCE_TOTAL_QUERY = gql(`
  query CompliancePageListAllocationComplianceTotal($page: Int!, $rowsPerPage: Int!) {
    ListAllocationCompliance(page: $page, rowsPerPage: $rowsPerPage) {
      total
    }
  }
`);

export const LIST_ALLOCATION_COMPLIANCE_QUERY = gql(`
  query CompliancePageListAllocationCompliance(
    $advisoryFirmFilter: String
    $allocationStatusFilter: String
    $page: Int!
    $rowsPerPage: Int!
    $sort: String
    $order: String
    $search: String
  ) {
    ListAllocationCompliance(
      advisoryFirmFilter: $advisoryFirmFilter
      allocationStatusFilter: $allocationStatusFilter
      page: $page
      rowsPerPage: $rowsPerPage
      sort: $sort
      order: $order
      search: $search
    ) {
      total
      page
      perPage
      allocations {
        id
        advisoryFirm {
          id
          name
          type
        }
        legalEntity {
          id
          entityName
          family {
            id
            name
          }
        }
        investment {
          id
          name
        }
        statusDate
        status
        details
        subscriptionDocuments {
          id
        }
      }
    }
  }
`);

export const GET_DUE_DILIGENCE_COMPLIANCE_RECORDS_TOTAL_QUERY = gql(`
  query CompliancePageListDueDiligenceComplianceRecordsTotal($data: DueDiligenceComplianceRecordsListDto!) {
    listDueDiligenceComplianceRecords(data: $data) {
      total
    }
  }
`);

export const LIST_DUE_DILIGENCE_COMPLIANCE_RECORDS_QUERY = gql(`
  query CompliancePageListDueDiligenceComplianceRecords($data: DueDiligenceComplianceRecordsListDto!) {
    listDueDiligenceComplianceRecords(data: $data) {
      total
      limit
      offset
      records {
        id
        investment {
          name
          id
          assetClass {
            id
            name
          }
          subAssetClass {
            id
            name
          }
        }
        status
        statusUpdatedAt
        approver {
          firstName
          lastName
          id
        }
        activeTier {
          name
          id
          funnel {
            id
            name
          }
        }
      }
    }
  }
`);

export const COMPLIANCE_PAGE_DEAL_DOCUMENTS_EMAIL_TRACKING_LIST_TOTAL_QUERY = gql(`
  query CompliancePageDealDocumentsEmailTrackingListTotal($data: SendDealDocumentsEmailTrackingInputDto!) {
    dealDocumentsEmailTrackingList(data: $data) {
      total
    }
  }
`);

export const COMPLIANCE_PAGE_DEAL_DOCUMENTS_EMAIL_TRACKING_FILTERABLE_INVESTMENTS_QUERY = gql(`
  query CompliancePageDealDocumentsEmailTrackingFilterableInvestments($data: SendDealDocumentsEmailTrackingInputDto!) {
    dealDocumentsEmailTrackingList(data: $data) {
      filterableInvestments {
        id
        name
      }
    }
  }
`);

export const COMPLIANCE_PAGE_DEAL_DOCUMENTS_EMAIL_TRACKING_LIST_QUERY = gql(`
  query CompliancePageDealDocumentsEmailTrackingList($data: SendDealDocumentsEmailTrackingInputDto!) {
    dealDocumentsEmailTrackingList(data: $data) {
      total
      page
      perPage
      dealDocumentTrackingData {
        action
        actionDate
        actionPerformedBy
        allocation {
          tenant {
            id
            name
          }
          id
          legalEntity {
            id
            entityName
            family {
              id
              name
            }
          }
          investment {
            id
            name
          }
          operationsWorkflowTransitionTask {
            id
            name
          }
          lastUpdatedAt
        }
        emailTrackingStatus
        assetFileNames
        emailRecipient
      }
    }
  }
`);
